import React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Microphone from './icon-microphone.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    const color = validProps.color || validProps.fill || colors.black;

    return <Microphone {...validProps} color={color} />;
}
SvgComponent.iconName = 'microphone';

/**
 * @deprecated This is a legacy icon
 */
export const MicrophoneIcon = svgIconWrapper(SvgComponent);
